var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mk-pagination',_vm._g({attrs:{"current-page":_vm.currentPage,"total":_vm.config.total,"page-size":10,"layout":"total, prev, pager, next, jumper"}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }